export default "__VITE_ASSET__C5WJL_CP__"